import { FacebookEvents } from 'facebook-events';

// ⛔ Eventi Facebook DISATTIVATI per ora.
// Il SDK nativo non è configurato (nessun Facebook App ID) e non usiamo ancora
// Meta Ads. Finché il flag è false queste funzioni sono no-op → nessun dato
// inviato a Meta (niente da dichiarare nel Data Safety di Google Play).
//
// PER RIATTIVARE (quando avvii Meta Ads):
//  1) crea l'app su Meta for Developers e configura lato nativo App ID +
//     client token (AndroidManifest/strings.xml, AutoInitEnabled/AutoLogAppEvents);
//  2) imposta VITE_FB_EVENTS_ENABLED=true nell'ambiente di build;
//  3) aggiorna il Data Safety dichiarando la condivisione con Meta
//     (ID dispositivo, attività app, acquisti).
const FB_EVENTS_ENABLED =
  ((import.meta as any).env?.VITE_FB_EVENTS_ENABLED ||
    (typeof process !== 'undefined' ? process.env.VITE_FB_EVENTS_ENABLED : undefined)) ===
  'true';

// Initializes Facebook SDK and tracks app activation
export async function initFacebookSdk() {
  if (!FB_EVENTS_ENABLED) return;
  try {
    await FacebookEvents.logEvent({ event: 'fb_mobile_activate_app' });
  } catch {
    // plugin might be unavailable during web development
  }
}

// Generic event logger with safe fallback
export async function logFacebookEvent(name: string, params?: Record<string, any>) {
  if (!FB_EVENTS_ENABLED) return;
  try {
    await FacebookEvents.logEvent({ event: name, params });
  } catch {}
}

// Set the current user ID for event tracking
export async function setFacebookUserId(userId: string | null) {
  if (!FB_EVENTS_ENABLED) return;
  try {
    await FacebookEvents.setUserId({ userId });
  } catch {}
}

// Track user registration event
export async function trackRegistration() {
  if (!FB_EVENTS_ENABLED) return;
  await logFacebookEvent('fb_mobile_complete_registration');
}

// Track purchase event with value and currency
export async function trackPurchase(value: number, currency = 'EUR') {
  if (!FB_EVENTS_ENABLED) return;
  await logFacebookEvent('fb_mobile_purchase', { value, currency });
}
